import { customList } from "country-codes-list";
import { getCountryCallingCode, getExampleNumber } from "libphonenumber-js";
import metadata from "libphonenumber-js/metadata.full.json"; // Required for full support

export const getCountryPhoneList = () => {
  const countryNameMap = customList("countryCode", "{countryNameEn}");

  return Object.entries(countryNameMap)
    .map(([countryCode, countryName]) => {
      try {
        const example = getExampleNumber(countryCode, metadata);
        return {
          name: countryName,
          iso: countryCode,
          code: `+${getCountryCallingCode(countryCode)}`,
          phoneLength: example?.nationalNumber?.length,
        };
      } catch {
        return null;
      }
    })
    .filter(Boolean);
};
